import { Subject } from 'rxjs'
import { reduceItemsByFilter } from 'utils/filter'

const fundItemsSubject = new Subject()

function nextByFilter(fundItems, filterData) {
  const filteredItems = reduceItemsByFilter(fundItems, filterData)
  fundItemsSubject.next(filteredItems)
}

export { fundItemsSubject, nextByFilter }
